import { Col, Row } from "antd";
import { CloudDownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { startDeleteFileProveedor, startDownloadDocumentoProveedor } from "../../../../../context/actions/proveedoresFilesActions";
import { emailsConAccesoDocumentos } from "../../../../../constants/cons";
//
export default function Item({ file }) {
  const dispatch = useDispatch();
  const { proveedorID } = useParams();
  const email = useSelector((state) => state.userReducer.user?.email);
  const puedeEliminar = emailsConAccesoDocumentos.includes(email);
  const { proveedorDocumentoID, url, nombre, } = file;

  const handleDownload = () =>
    dispatch(startDownloadDocumentoProveedor(proveedorDocumentoID, nombre, url));

  const handleDelete = () =>
    dispatch(startDeleteFileProveedor(proveedorDocumentoID, proveedorID));
  return (
    <Row gutter={10} className="rowTabla">
      <Col span={5}>{nombre}</Col>

      <Col span={3} style={{ textAlign: "right" }}>
        <CloudDownloadOutlined
          onClick={handleDownload}
          className="icon"
          style={{ color: "blue" }}
        />
        {puedeEliminar && (
          <DeleteOutlined
            onClick={handleDelete}
            className="icon"
            style={{ color: "#ca2228" }}
          />
        )}
      </Col>
    </Row>
  );
}
